<template>
  <div
    class="localnote"
    :class="{'localnote--disabled': note.inherited}"
  >
    <div class="localnote__content">
      <BaseFormField label="Ikon">
        <IconPicker
          v-model="note.iconID"
          :extended="true"
        />
      </BaseFormField>

      <BaseInput
        v-model="note.headline"
        label="Overskrift"
        :disabled="note.inherited"
      />
      <BaseTextarea
        v-model="note.description"
        label="Beskrivelse"
        :disabled="note.inherited"
      />

      <LocalLinks :form="note" />

      <p
        class="localnote__delete localnote__delete--right"
        @click="$emit('remove')"
      >
        {{ note.inherited ? 'Nedarvet' : 'Fjern note' }}
      </p>
    </div>
  </div>
</template>

<script>
import LocalLinks from './LocalLinks.vue';
import BaseTextarea from './BaseTextarea.vue';
import BaseFormField from './BaseFormField.vue';
import IconPicker from './IconPicker.vue';
import BaseInput from './BaseInput.vue';

export default {
    name: 'LocalNote',
    components: {
        BaseInput, IconPicker, BaseFormField, BaseTextarea, LocalLinks,
    },
    props: {
        note: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
    },
};
</script>

<style lang="scss" scoped>
.localnote {
    display: flex;

    &--disabled {
        pointer-events: none;
        opacity: 0.5;
        user-select: none;
    }

    &:not(:last-child) {
        margin-bottom: 30px;
    }

    &__icon {
        width: 100px;
    }

    &__content {
        flex-grow: 1;
    }

    &__delete {
        font-weight: 300;
        font-size: 12px;
        font-style: italic;
        width: 100%;
        cursor: pointer;
        user-select: none;

        &--right {
            text-align: right;
        }
        &--link {

        }
    }
}
</style>
